/**
 * Formats a patient-parameter option label for display.
 *
 * Age option values are stored zero-padded (a sort artifact, e.g. "08" / "054")
 * so they order correctly as strings. For display we strip a single leading zero
 * so users see "8" / "54" instead of "08" / "054". We intentionally do NOT
 * parseInt — that would collapse legitimately distinct labels and lose any
 * non-numeric formatting. We also only strip when more than one char remains, so
 * a genuine "0" (infant) age option is never collapsed to an empty label.
 *
 * Centralizing this here keeps every read-only view (Tags, PatientsList,
 * ShowParams, request emails) and the edit widget in sync.
 */
export function formatParamOptionLabel(
  slug: string | undefined,
  label: string | undefined,
): string {
  if (!label) return '';
  if (slug === 'age' && label[0] === '0' && label.length > 1) {
    return label.slice(1);
  }
  return label;
}
